import { SelectFieldOption } from '@resurs-internal/mui/components/SelectField/SelectFieldOption';

import Select from '../SelectField/SelectField';
import { countries } from './countries';

type Props = {
    name: string;
    label: string;
    options?: SelectFieldOption[];
};

/**
 * `options` can override the static bundled `countries` list once backend exposes
 * a canonical country list (mirrors how KYC's `kycCountries` is backend-supplied).
 */
const CountryOfBirthField = ({ name, label, options }: Props) => {
    return <Select name={name} label={label} options={options ?? countries} />;
};

export default CountryOfBirthField;
